var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "input-content" }, [
    _c(
      "div",
      {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: _vm.microphoneShow,
            expression: "microphoneShow"
          }
        ],
        attrs: { id: "microphone-block" }
      },
      [
        _c("div", { staticClass: "green-ball" }),
        _vm._v(" "),
        _c("span", { staticClass: "microphone-text" }, [
          _vm._v(
            "\n                正在录音...(" +
              _vm._s(_vm.recordTime) +
              ")s\n            "
          )
        ]),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "float-r mt-3" },
          [
            _c(
              "el-button",
              {
                attrs: { size: "mini", type: "primary", plain: "" },
                on: { click: _vm.sendVoice }
              },
              [_vm._v("发送")]
            ),
            _vm._v(" "),
            _c(
              "el-button",
              { attrs: { size: "mini" }, on: { click: _vm.cancelVoice } },
              [_vm._v("取消")]
            )
          ],
          1
        )
      ]
    ),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "toolbar" },
      [
        _c(
          "el-popover",
          { attrs: { placement: "top", width: "400", trigger: "click" } },
          [
            _c(
              "div",
              { staticClass: "cursor", staticStyle: { "font-size": "24px" } },
              _vm._l(_vm.emojis, function(item, key) {
                return _c(
                  "span",
                  {
                    key: key,
                    on: {
                      click: function($event) {
                        return _vm.setEmoji(item.char)
                      }
                    }
                  },
                  [_vm._v(_vm._s(item.char))]
                )
              }),
              0
            ),
            _vm._v(" "),
            _c("span", {
              staticClass: "fa fa-smile-o",
              attrs: { slot: "reference", id: "smileSpan" },
              slot: "reference"
            })
          ]
        ),
        _vm._v(" "),
        _c("span", {
          staticClass: "iconfont icon-fasongtupian",
          attrs: { title: "图片", id: "picSpan" },
          on: { click: _vm.pictureClick }
        }),
        _vm._v(" "),
        _c("span", {
          staticClass: "iconfont icon-jietu",
          attrs: { title: "截图", id: "screenShot" },
          on: { click: _vm.screenShoot }
        }),
        _vm._v(" "),
        _c(
          "el-upload",
          {
            staticClass: "inline-block",
            attrs: {
              action: _vm.action,
              "on-success": _vm.successUpload,
              "show-file-list": false
            }
          },
          [
            _c("span", {
              staticClass: "iconfont icon-fasongwenjian",
              attrs: { title: "文件", id: "fileSpan" }
            })
          ]
        ),
        _vm._v(" "),
        _c("span", {
          staticClass: "iconfont icon-yuyinliaotian",
          attrs: { title: "语音", id: "microphone" },
          on: { click: _vm.microphoneClick }
        }),
        _vm._v(" "),
        _c("span", {
          staticClass: "iconfont icon-liaotianjilu",
          attrs: { title: "聊天记录", id: "history" },
          on: {
            click: function($event) {
              return _vm.historyClick(true)
            }
          }
        }),
        _vm._v(" "),
        _c("button", { attrs: { id: "send" }, on: { click: _vm.sendMsg } }, [
          _c("span", { staticClass: "iconfont icon-fasong-copy" }),
          _vm._v("发送")
        ])
      ],
      1
    ),
    _vm._v(" "),
    _c("div", {
      attrs: { id: "input-main", rows: "5", contenteditable: "true" }
    }),
    _vm._v(" "),
    _c("input", {
      directives: [
        { name: "show", rawName: "v-show", value: false, expression: "false" }
      ],
      attrs: { id: "pic-input", type: "file", accept: "image/*" },
      on: { change: _vm.picChooseChange }
    })
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-69c66d8e", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-69c66d8e","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./packages/chat/src/input-send.vue
// module id = null
// module chunks = 